export const getTableOptions = context => context.table.options
export const getPinnedColumns = context => getTableOptions(context).state.columnPinning.left
export const getTableMeta = context => getTableOptions(context).meta
export const getTableName = context => getTableMeta(context).tableName
